import { Inject, Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { catchError, map, tap } from 'rxjs';
import { ApplicationControllerService } from './cc-api/services/application-controller.service';
import { of } from 'rxjs';
import { DOCUMENT } from '@angular/common';
import { FeatureFlagsService } from './services/feature-flags.service';
import { UserService } from './services/user.service';
import { LocalStorageService } from './services/local-storage.service';

@Injectable()
export class AuthGuard implements CanActivate {
  private roles: string[] = [];
  constructor(
    private applicationControllerService: ApplicationControllerService,
    private router: Router,
    private featureFlagService: FeatureFlagsService,
    private localStorage: LocalStorageService,
    private userService: UserService,
    @Inject(DOCUMENT) private document: any,
  ) {}

  canActivate() {
    return this.applicationControllerService.meUsingGET().pipe(
      map((res) => {
        this.userService.setUser(res);
        res.authorities.forEach((a) =>
          this.roles.push(a.authority?.toLowerCase()),
        );
        return true;
      }),
      catchError((err) => of(false)),
      tap((authenticated) => {
        if (!authenticated) {
          let logoutUrl = this.featureFlagService.getLogoutUrl();
          try {
            const localStorageLogoutURL = localStorage?.getItem('logoutUrl');
            if (!logoutUrl && localStorageLogoutURL) {
              logoutUrl = localStorageLogoutURL;
            }
          } catch (err) {}
          if (logoutUrl) {
            window.location.href = `${window.location.origin}/${logoutUrl}`;
          } else {
            this.router.navigate(['/login']);
          }
        }
      }),
    );
  }

  checkRole(roleName): boolean {
    return this.roles.indexOf('role_' + roleName?.toLowerCase()) != -1;
  }
}
